module.exports = __webpack_public_path__ + "img/default-CBC.f54c2a51.svg";